import { adFormatMapping, type AdFormats } from '$lib/services/advertising';
import { isMobile } from '$lib/services/mediaQuery/screenSize';
import { get } from 'svelte/store';

export function getAdFormatFromDevice(adFormat: AdFormats, device: 'mobile' | 'desktop') {
	if (typeof adFormat === 'string') {
		return adFormat;
	}

	return adFormat[device];
}

export function getAdFormatFromDeviceWidth(adFormat: AdFormats) {
	if (get(isMobile)) {
		return getAdFormatFromDevice(adFormat, 'mobile');
	}

	return getAdFormatFromDevice(adFormat, 'desktop');
}

/**
 * Returns the ad size for the given device.
 *
 * Useful when we want to be able to reserve space for the ad
 * before it loads.
 */
export function getAdSizeFromDevice(adFormat: AdFormats, device: 'mobile' | 'desktop') {
	const adFormatForDevice = getAdFormatFromDevice(adFormat, device);

	const adSize = adFormatForDevice ? adFormatMapping[adFormatForDevice] : [[0, 0]];

	// Retrieve the biggest container size from the ad size
	// Eg: [[300, 250], [300, 600]] => [300, 600]
	return [
		Math.max(...adSize.map(([width]) => width)),
		Math.max(...adSize.map(([, height]) => height)),
	];
}

export function generateRandomNumber() {
	return Math.floor(Math.random() * 900000000) + 100000000;
}

export function getDevice() {
	return get(isMobile) ? 'mobile' : 'desktop';
}
